import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from 'react';
import { WithProviders } from '@atlaskit/editor-common/provider-factory';
import { isResolvingMentionProvider, MentionNameStatus } from '@atlaskit/mention';
import { isPromise } from '@atlaskit/mention/types';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import Mention from '../ui/Mention';
import { Mention as MentionNext } from '../ui/Mention/mention';
var UNKNOWN_USER_ID = '_|unknown|_';
var MentionAssistiveTextComponent = function MentionAssistiveTextComponent(_ref) {
  var id = _ref.id,
    text = _ref.text,
    providers = _ref.providers,
    accessLevel = _ref.accessLevel,
    mentionProvider = _ref.mentionProvider,
    localId = _ref.localId;
  var _useState = useState(text),
    _useState2 = _slicedToArray(_useState, 2),
    resolvedName = _useState2[0],
    setResolvedName = _useState2[1];
  var processName = function processName(name) {
    if (name.status === MentionNameStatus.OK) {
      return "@".concat(name.name || '');
    } else {
      return "@".concat(UNKNOWN_USER_ID);
    }
  };
  useEffect(function () {
    if (mentionProvider) {
      mentionProvider.then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(provider) {
          var nameDetail;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!(!text && isResolvingMentionProvider(provider))) {
                  _context.next = 13;
                  break;
                }
                nameDetail = provider.resolveMentionName(id);
                if (!isPromise(nameDetail)) {
                  _context.next = 10;
                  break;
                }
                _context.t0 = processName;
                _context.next = 6;
                return nameDetail;
              case 6:
                _context.t1 = _context.sent;
                return _context.abrupt("return", (0, _context.t0)(_context.t1));
              case 10:
                return _context.abrupt("return", processName(nameDetail));
              case 11:
                _context.next = 14;
                break;
              case 13:
                return _context.abrupt("return", text);
              case 14:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }()).then(function (resolvedName) {
        setResolvedName(resolvedName);
      });
    }
  }, [id, text, mentionProvider]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Mention, {
    id: id,
    text: resolvedName,
    accessLevel: accessLevel,
    providers: providers,
    localId: localId
  })));
};
export var MentionNodeView = function MentionNodeView(props) {
  var providerFactory = props.providerFactory;
  var _props$node$attrs = props.node.attrs,
    id = _props$node$attrs.id,
    text = _props$node$attrs.text,
    accessLevel = _props$node$attrs.accessLevel,
    localId = _props$node$attrs.localId;
  var renderAssistiveTextWithProviders = function renderAssistiveTextWithProviders(providers) {
    var _props$options;
    var _ref3 = providers,
      mentionProvider = _ref3.mentionProvider;
    var profilecardProvider = getBooleanFF('platform.editor.mentions-in-editor-popup-on-click') ? (_props$options = props.options) === null || _props$options === void 0 ? void 0 : _props$options.profilecardProvider : undefined;
    if (profilecardProvider) {
      return (
        /*#__PURE__*/
        /**
         * Rename this to `Mention` when `platform.editor.mentions-in-editor-popup-on-click` is tidied up.
         */
        React.createElement(MentionNext, {
          id: id,
          text: text,
          accessLevel: accessLevel,
          mentionProvider: mentionProvider,
          profilecardProvider: profilecardProvider,
          localId: localId
        })
      );
    } else {
      return /*#__PURE__*/React.createElement(MentionAssistiveTextComponent, {
        mentionProvider: mentionProvider,
        id: id,
        text: text,
        providers: providerFactory,
        accessLevel: accessLevel,
        localId: localId
      });
    }
  };
  return /*#__PURE__*/React.createElement(WithProviders, {
    providers: ['mentionProvider', 'profilecardProvider'],
    providerFactory: providerFactory,
    renderNode: renderAssistiveTextWithProviders
  });
};